<template>
  <div>
    <v-card v-if="Seleccionado" color="fondoformulario">
      <v-card-title>ACTUALIZAR DATOS DE CONTACTO</v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="2" cols="12">
            <v-text-field
              hide-details
              placeholder=" "
              outlined
              dense
              v-model="Seleccionado.telefono"
              label="Telefono"
            ></v-text-field>
          </v-col>
          <v-col md="3" cols="12">
            <v-text-field
              hide-details
              placeholder=" "
              outlined
              dense
              v-model="Seleccionado.mail"
              label="mail"
            ></v-text-field>
          </v-col>
          <v-col md="3" cols="12">
            <v-text-field
              hide-details
              placeholder=" "
              outlined
              dense
              v-model="Seleccionado.domicilio"
              label="Domicilio"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="1">
            <v-text-field
              hide-details
              placeholder=" "
              outlined
              dense
              v-model="Seleccionado.codigo_postal"
              label="C.Postal"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <cboLocalidades v-model="localidad"></cboLocalidades>
          </v-col>
          <v-col cols="12" md="3">
            <provSeleccionada
              :id_provincia="Seleccionado.id_provincia"
              outlined
            ></provSeleccionada>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valida" class="primary" @click="guardar()">
          <v-icon left>mdi-content-save</v-icon>
          Guardar</v-btn
        >
      </v-card-actions>
      <h4 class="red--text">{{ observaciones }}</h4>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import provSeleccionada from "@/components/Provincias/Seleccionada";
import cboLocalidades from "@/components/Localidades/Combo";
import API from "../../../lib/API";
import LUM from "../../../lib/LUM";
export default {
  data() {
    return {
      valida: true,
    };
  },
  components: {
    provSeleccionada,
    cboLocalidades,
  },
  computed: {
    ...mapState("beneficiarios", ["Titular", "GrupoFamiliar", "Seleccionado"]),
    ...mapState("autogestion", ["Usuario"]),
    logueado() {
      return this.Seleccionado !== undefined && this.Seleccionado !== null;
    },
    localidad: {
      get: function() {
        return {
          id_localidad: this.Seleccionado.id_localidad,
          codigo_postal: this.Seleccionado.codigo_postal,
          id_provincia: this.Seleccionado.id_provincia,
        };
      },
      set: function(newValue) {
        this.Seleccionado.id_localidad = newValue.id_localidad;
        this.Seleccionado.id_provincia = newValue.id_provincia;
      },
    },
    observaciones() {
      this.valida = true;
      let obs = "";
      if (this.Seleccionado.mail == "") {
        obs += " * ingrese un mail";
      }
      if (!LUM.validateEmail(this.Seleccionado.mail)) {
        obs += " * email incorrecto";
      }
      if (this.Seleccionado.telefono.trim().length != 10) {
        obs += " * Telefono incorrecto";
      }
      if (this.Seleccionado.domicilio.trim().length == 0) {
        obs += " * Ingrese el domicilio";
      }

      if (isNaN(this.Seleccionado.codigo_postal)) {
        obs += " * Codigo postal debe ser numerico";
      }
      if (
        this.Seleccionado.codigo_postal < 1000 ||
        this.Seleccionado.codigo_postal > 9999
      ) {
        obs += " * Codigo postal incorrecto ";
      }
      if (obs) {
        this.valida = false;
      }

      return obs;
    },
  },
  methods: {
    ...mapActions("autogestion", ["inicializar"]),
    ...mapActions("beneficiarios", ["select", "modificarBeneficiario"]),
    guardar() {
      this.modificarBeneficiario(this.Seleccionado);
      this.$router.push({ name: "PracticasAutogestion" });
    },
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar();
      if (!this.Usuario){
        this.$router.push({ name: "Autogestion" });
      }
    }
    if (this.Usuario && this.Seleccionado == undefined) {
      let ben = await API.Beneficiarios.traerUno(this.Usuario.UserId);
      this.select(ben);
    }
  },
};
</script>

<style></style>
